var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"settings-page",attrs:{"padding":""}},[_c('area-manager-form',{attrs:{"is-edit":true,"peer-group-id":_vm.areaManagerId,"back-location":{ name: 'settings:area-manager' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }